import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ToastController } from 'ionic-angular';
import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';

import { InboxCreateTimeeventPage } from '../inbox-create-timeevent/inbox-create-timeevent';
import { HomePage } from '../home/home';


import { LeistungProvider } from '../../providers/leistung/leistung';

/**
 * Generated class for the InboxPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-inbox',
  templateUrl: 'inbox.html',
})
export class InboxPage {
  Inbox = [];
  loading: any;
  timeEventItem: any;
  selectedCustomer:string = '';
  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
  	public loadingCtrl: LoadingController,
  	public modalCtrl: ModalController,
    public leistungCtrl: LeistungProvider,
    public toastCtrl: ToastController ) {


  	this.getData();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InboxPage');
  }

  doRefresh(refresher){
  	this.getData();
  	refresher.complete();
  }
  getData(){
  	this.loading = this.loadingCtrl.create({
		  content: 'einen Moment...'
	  });
  	this.loading.present();

  	this.rhynoApi.getInbox().subscribe(
  		data => {
  		if (data.success){
  			this.Inbox = data.data; 
  		}else{
        this.presentToast(data.message, 'error');
      }
      this.loading.dismiss();

  	},
  		err => {
  		console.log(err);
  		this.loading.dismiss();
  	},
  	() => console.log('Inbox Search Complete')
  	);
  }

  createTimeEvent(){
  	this.timeEventItem = {};
  	this.Inbox.forEach(item => {
    	if (item.selected){
    		if (this.timeEventItem.MengeExtern){
    			this.timeEventItem.MengeExtern = this.timeEventItem.MengeExtern + new Date(item.duration).getUTCHours()+(1/60*new Date(item.duration).getUTCMinutes());
    		}else{
    			this.timeEventItem = item;
    			this.timeEventItem.MengeExtern = new Date(item.duration).getUTCHours()+(1/60*new Date(item.duration).getUTCMinutes());
    		}
    	}
	});

  	this.timeEventItem.MengeExtern = Math.ceil(this.timeEventItem.MengeExtern*4)/4;

  	let profileModal = this.modalCtrl.create(InboxCreateTimeeventPage, this.timeEventItem);
  	profileModal.onDidDismiss(data => {
    	console.log(data);
    	if (data){

    		this.timeEventItem.Leistung = data.Leistung;
    		this.timeEventItem.Beschreibung = data.Beschreibung;

    		this.timeEventItem.ProjektID = data.ProjektID;
    		this.timeEventItem.ProjektIDExt = data.ProjektIDExt;
    		this.timeEventItem.ProjektBezeichnung = data.ProjektBezeichnung;
        
    		this.timeEventItem.Kunde = data.Kunde;
    		this.timeEventItem.KundeName = data.KundeName;

    		
		  	if (this.timeEventItem){
		  		//this.navCtrl.setRoot(HomePage, this.timeEventItem);
          this.leistungCtrl.leistung = this.leistungCtrl.initLeistungFromInbox(this.timeEventItem);
          this.leistungCtrl.calculatePrice();
          this.clearSelections();
          this.new();
		  	}

    	}
   	});

    profileModal.present();

	
  }
  new(){
    let data = {
      presettings: {
      }
    };
        this.navCtrl.push(HomePage, data);

  }

  sameCustomer(kunde):string{
    
    if (this.selectedCustomer == '' || this.selectedCustomer == kunde){
      return "false";
    }else{
      return "true";
    }
  }
  updateSelectedCustomer(kunde){
    if (this.Inbox.filter(item => item.selected == true).length > 0){
      this.selectedCustomer = kunde;
    }else{
      this.selectedCustomer = '';
    }
    
  }
  clearSelections(){
    this.Inbox.forEach(data=>{
      data.selected=false;
    });
  }

  deleteSelectedItems(){
    this.Inbox.forEach(item=>{
      if (item.selected==true){
        this.rhynoApi.deleteInboxItem(item.EVENT_ID);
      }
    });
    this.clearSelections();
  }

  presentToast(message,type) {
    var style = '';
    switch (type) {
       case "success":
         style = 'toast-success';
         break;
       case "error":
         style = 'toast-error';
         break;
     } 

    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false,
      cssClass: style
    });
    toast.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/inbox/inbox.ts